import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable()
export class AppMessageService extends MessageService {
  private readonly lastMessageBySeverity = new Map<string, number>();
  private readonly burstWindowMs = 800;

  override add(message: ToastMessageOptions): void {
    if (this.shouldSuppress(message)) return;
    super.add(message);
  }

  override addAll(messages: ToastMessageOptions[]): void {
    messages.forEach((message) => this.add(message));
  }

  private shouldSuppress(message: ToastMessageOptions): boolean {
    const now = Date.now();
    const severity = message.severity || 'info';
    const lastShownAt = this.lastMessageBySeverity.get(severity) ?? 0;

    if (now - lastShownAt < this.burstWindowMs) return true;

    this.lastMessageBySeverity.set(severity, now);
    return false;
  }
}
